// extracted by mini-css-extract-plugin
module.exports = {"collectionsWrapper":"collections-list_collectionsWrapper__hc0CE"};